import { StyledHeader, Nav, Logo, Image } from "./styles/Header.styled"
import { Container } from "./styles/Container.styled"
import { Flex } from "./styles/Flex.styled"
import { Button } from './styles/Button.styled'

export default function Header() {
    return (
        <StyledHeader>
            <Container>
            <Nav>
                <Logo src='./images/logo.svg' alt='' />
                <Button>Try It Free</Button>
            </Nav>

            <Flex>
          <div>
            <h1>Build The Community Your Fans Will Love</h1>

            <p>Muotoiluun käytän näillä sivuilla Styled Components - komponettia.</p>
            
            <a href="https://styled-components.com/" target="_blank" rel="noreferrer">
              <Button bg='#0091ff' color='#fff'>
                Styled Components
              </Button>
            </a>
            <br />
            <p>Traversy Median video miten nämä sivut tehdään:</p>
            <a href="https://www.youtube.com/watch?v=02zO0hZmwnw" target="_blank" rel="noreferrer">
              <Button bg='#0091ff' color='#fff'>
                YouTube video
              </Button>
            </a>
            <br/>
            <p>Linkki react-icons sivulle:</p>
            <a href="https://react-icons.github.io/react-icons" target="_blank" rel="noreferrer">
            <Button bg='#0091ff' color='#fff'>
              React-icons
              </Button>
            </a>
            <p>
              Huddle re-imagines the way we build communities. You have a voice,
              but so does your audience. Create connections with your users as
              you engage in genuine discussion.
            </p>

            <Button bg='#ff0099' color='#fff'>
              Get Started For Free
            </Button>
          </div>

          <Image src='./images/illustration-mockups.svg' alt='' />
        </Flex>
            </Container>
        </StyledHeader>
    )
}